import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import CookieConsentBanner from "../CookieConsentBanner";
import useUserStore from "../../stores/user";
import { useT } from "../../stores/uiLang";
import { PE_T } from "../../i18n/peLesson";

export function TeacherGuidesLayout() {
  // This layout renders no global <Header/>, so it must load the user profile
  // itself — the same store.fetchUserProfile the Header calls. The native
  // student-lesson route (/student/lesson/:assignmentId) nested here is gated by
  // RoleRoute, which blocks on `profile` (`if (!profile) return null`). Without
  // this load `profile` never resolves on a cold load and RoleRoute renders null
  // forever — a blank screen (same failure PresentationLayout fixes for the
  // projection route). The sibling guides routes don't gate on profile, so this
  // is purely additive for them.
  const user = useUserStore((s) => s.user);
  const profile = useUserStore((s) => s.profile);
  const fetchUserProfile = useUserStore((s) => s.fetchUserProfile);
  // Run E2 J5: the toast region's screen-reader label follows the UI language
  // (the student lesson route lives in this layout).
  const t = useT(PE_T);

  useEffect(() => {
    if (user && !profile) fetchUserProfile(user);
  }, [user, profile, fetchUserProfile]);

  return (
    <div>
      <ToastContainer aria-label={t.notificationsAria} />
      <main className="">
        <Outlet />
      </main>
      <CookieConsentBanner />
    </div>
  );
}
